import { render } from "./TaktRelatedChart.vue?vue&type=template&id=03e08848&scoped=true"
import script from "./TaktRelatedChart.vue?vue&type=script&lang=js"
export * from "./TaktRelatedChart.vue?vue&type=script&lang=js"

import "./TaktRelatedChart.vue?vue&type=style&index=0&id=03e08848&scoped=true&lang=css"

import exportComponent from "/home/runner/work/acp-portal-frontend/acp-portal-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03e08848"]])

export default __exports__